// extracted by mini-css-extract-plugin
export default {"logoutIcon__mobile":"Logout_logoutIcon__mobile__tKRvU","logoutButton":"Logout_logoutButton__XBV+1"};